
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    export class IcReport02_VDialog extends Serenity.EntityDialog<IcReport02_VRow, any> {
        protected getFormKey() { return IcReport02_VForm.formKey; }
        protected getIdProperty() { return IcReport02_VRow.idProperty; }
        protected getLocalTextPrefix() { return IcReport02_VRow.localTextPrefix; }
        protected getNameProperty() { return IcReport02_VRow.nameProperty; }
        protected getService() { return IcReport02_VService.baseUrl; }
        protected getDeletePermission() { return IcReport02_VRow.deletePermission; }
        protected getInsertPermission() { return IcReport02_VRow.insertPermission; }
        protected getUpdatePermission() { return IcReport02_VRow.updatePermission; }

        protected form = new IcReport02_VForm(this.idPrefix);
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }
    }
}